import { ArrowLeft, Loader2 } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { trpc } from "~/api/trpc";
import { Button } from "~/components/ui/button";
import Content from "../components/layout/Content";
import PractitionerForm from "../components/practitioners/PractitionerForm";

const Practitioner = () => {
    const params = useParams();
    const navigate = useNavigate();

    const id = parseInt(params.id!, 10);

    const { data, isLoading, error } = trpc.practitioners.getOne.useQuery(
        { id },
        { enabled: !isNaN(id) }
    );

    if (isLoading) {
        return (
            <Content>
                <div className="container mx-auto py-10">
                    <div className="flex items-center justify-center min-h-[400px]">
                        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
                    </div>
                </div>
            </Content>
        );
    }

    if (error || !data) {
        return (
            <Content>
                <div className="container mx-auto py-10">
                    <div className="bg-white rounded-lg shadow-sm p-8 text-center">
                        <h2 className="text-xl font-semibold text-gray-900 mb-2">
                            Ups...
                        </h2>
                        <p className="text-gray-600 mb-6">
                            {error?.message || "Der Behandler konnte nicht gefunden werden."}
                        </p>
                        <Button onClick={() => navigate("/practitioners")}>
                            <ArrowLeft className="mr-2 h-4 w-4" />
                            Zurück zur Übersicht
                        </Button>
                    </div>
                </div>
            </Content>
        );
    }

    const practitionerName = [data.title, data.firstName, data.lastName]
        .filter(Boolean)
        .join(" ");

    return (
        <Content>
            <div className="container mx-auto py-10">
                <div className="mb-6">
                    <Button
                        variant="ghost"
                        onClick={() => navigate("/practitioners")}
                        className="mb-4"
                    >
                        <ArrowLeft className="mr-2 h-4 w-4" />
                        Zurück zur Übersicht
                    </Button>
                    <h1 className="text-2xl font-bold">
                        {practitionerName} bearbeiten
                    </h1>
                </div>
                <PractitionerForm />
            </div>
        </Content>
    );
};

export default Practitioner;
